import Insights from "@/components/sections/Insights";
import PageHeader from "@/components/PageHeader";
import SEO from "@/components/SEO";
import { SEO_MAP } from "@/lib/seoMap";

export default function InsightsPage() {
  return (
    <main data-testid="insights-page">
      <SEO {...SEO_MAP.insights} />
      <PageHeader overline="Insights" title={<>Writing from<br /><em className="italic">the build floor</em>.</>}
                  lead="Long-form thinking on how software, design and operations combine into a durable advantage." />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-6 -mt-6">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-8">
            <p className="text-[15px] text-[color:var(--text-muted)] leading-relaxed">
              LaneX Labs Insights is where our engineers, designers and operators write about the craft
              behind modern digital businesses — the practices that separate a shipped product from a
              shipped brochure. Expect essays and playbooks on performance budgets, design systems,
              accessibility, motion, automation, workflow tooling, custom CRMs, client portals and the
              security posture every founder should treat as table stakes. We publish deliberately, not
              constantly: each article reflects work we've actually done, mistakes we've actually made,
              and patterns we're actively refining across enterprise, SME and startup engagements. Bookmark
              this page or subscribe via the footer — new pieces appear here as our teams find something
              worth writing down.
            </p>
          </div>
        </div>
      </section>

      <Insights limit={20} />
    </main>
  );
}
